/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-config.js to modify the generation of this file.
const config = {};
config.sitecoreApiKey = process.env.REACT_APP_SITECORE_API_KEY || "{B2B3E139-76C3-48D9-8D7C-038C1CEE4B5C}";
config.sitecoreApiHost = process.env.REACT_APP_SITECORE_API_HOST || "https://www.omodajaecoo.be";
config.sitecoreSiteName = process.env.REACT_APP_SITECORE_SITE_NAME || "be-site";
config.graphQLEndpointPath = process.env.REACT_APP_GRAPH_QL_ENDPOINT_PATH || "/sitecore/api/graph/edge";
config.defaultLanguage = process.env.REACT_APP_DEFAULT_LANGUAGE || "en";
config.graphQLEndpoint = process.env.REACT_APP_GRAPH_QL_ENDPOINT || "https://www.omodajaecoo.be/sitecore/api/graph/edge";
config.layoutServiceConfigurationName = process.env.REACT_APP_LAYOUT_SERVICE_CONFIGURATION_NAME || "default";
module.exports = config;